import { type HTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

export const MapPreviewOverlay = ({
  blur,
  className,
  children,
}: HTMLAttributes<HTMLDivElement> & {
  blur: boolean;
}) => (
  <div
    className={twMerge(
      "absolute left-0 top-0 flex h-full w-full items-end justify-end gap-2 rounded-xl p-4",
      blur && "items-center justify-center bg-white/50 backdrop-blur-[2px]",
      className,
    )}
  >
    {children}
  </div>
);
